import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  insightData: [],
  totalinsight: 0,
  isOpenModal: false,
  isImageOpenModal: false,
  isPdfOpenModal: false,
  isStatusOpenModal: false,
}

export const insightSlice = createSlice({
  name: "insight",
  initialState,
  reducers: {
    setinsightData(state, { payload }) {
      state.insightData = payload.result
      state.totalinsight = payload.count
    },
    updateinsightData(state, { payload }) {
      const objIndex = state.insightData.findIndex((obj) => obj.id === payload.id);
      if (objIndex >= 0) {
        state.insightData[objIndex] = payload
      }
    },
    pushinsightData(state, { payload }) {
      state.insightData.push(payload)
    },
    sliceTestData(state, { payload }) {
      const objIndex = state.insightData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.insightData.splice(objIndex, 1)
      }
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
    isImageOpenModal(state, { payload }) {
      state.isImageOpenModal = payload
    },
    ImagestatusToggle(state, { payload }) {
      state.isImageOpenModal = !state.isImageOpenModal
    },
    isPdfOpenModal(state, { payload }) {
      state.isPdfOpenModal = payload
    },
    PdfstatusToggle(state, { payload }) {
      state.isPdfOpenModal = !state.isPdfOpenModal
    },
    isOpenStatusModal(state, { payload }) {
      state.isStatusOpenModal = payload
    },
    statusToggle(state, { payload }) {
      state.isStatusOpenModal = !state.isStatusOpenModal
    },
  }
})

export const { setinsightData, updateinsightData, pushinsightData, sliceTestData, isOpenModal, ModalToggle, isImageOpenModal, ImagestatusToggle, isPdfOpenModal, PdfstatusToggle,  isOpenStatusModal, statusToggle  } = insightSlice.actions;

export default insightSlice.reducer;

export function getinsight(limit, offset, status) {
  return async function getinsightThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getinsight(limit, offset, status).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setinsightData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addinsight(payload) {
  return async function addinsightThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addinsight(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushinsightData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateinsight(id, data) {
  return async function updateinsightThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateinsight(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updateinsightData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateInsightStatus(id, status) {
  return async function updateInsightStatusThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateInsightStatus(id, status).then(
        (response) => {
          dispatch(statusToggle())
          dispatch(setLoading(false))
          dispatch(updateinsightData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateinsightImage(id, name) {
  return async function updateinsightImageThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateinsightImage(id, name).then(
        (response) => {
          dispatch(ImagestatusToggle())
          dispatch(setLoading(false))
          dispatch(updateinsightData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateinsightPdf(id, name) {
  return async function updateinsightPdfThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateinsightPdf(id, name).then(
        (response) => {
          dispatch(PdfstatusToggle())
          dispatch(setLoading(false))
          dispatch(updateinsightData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function deleteinsightImage(id) {
  return async function deleteinsightImageThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.deleteInsight(id, 'deleted').then(
        (response) => {
          dispatch(sliceTestData(id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

